<template>
<v-container class="mx-5 mt-n2 table-container">
        <item-list :items="projects" :itemsPerPage="itemsPerPage" :headers="headers" :bottomText="$t('changed.perPage')" 
            @search="searchInput" @sortBy="getSortedBy" :searchLabel="$t('searchHistory')" :title="$t('statistics')">
        <template slot="tfooter">
            <table-footer :key="footerKey" :page="page" ref="tfooter" :rangeDate="range" :status="startDate" :itemSelected="itemsPerPage" :search="search" 
            :tableInfo="this.$extractions.getSystemPagingInfo" @callback="setRequestInterval" />
        </template>
        </item-list>
        <v-container class="total-container">
        <v-layout class="tables">
            <v-row>
                <v-col cols="12" lg="6">
                    <p class="title-statistics mt-2">{{$t('total')}}</p>
                    <v-simple-table class="simple-table">
                        <tbody>
                             <tr class="gris">
                                <td class="header-table">{{ $t('totalProjectsPreApproved') }}</td>
                                <td class="text-right table-data">{{ totalProjects.totalProjectsPreApproved }}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{ $t('totalProjectsApproved') }}</td>
                                <td class="text-right table-data">{{ totalProjects.totalProjectsApproved }}</td>
                            </tr>
                            <tr class="gris">
                                <td class="header-table">{{ $t('totalProjectsDenied') }}</td>
                                <td class="text-right table-data">{{ totalProjects.totalProjectsDenied }}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{ $t('totalProjectsCreated') }}</td>
                                <td class="text-right table-data">{{ totalProjects.totalProjectsCreated }}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{ $t('totalDownloads') }}</td>
                                <td class="text-right table-data">{{ totalProjects.totalDownloadsProjects }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" lg="6">
                    <p class="title-statistics mt-2">{{$t('average')}}</p>
                    <v-simple-table class="simple-table">
                        <tbody>
                            <tr class="gris">
                                <td class="header-table">{{ $t('timeFromFinishedToPreApproved') }}</td>
                                <td class="text-right table-data">{{ formatTime(averageProjects.averageCreatedPreApproved) }}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{ $t('timeFromPreApprovedToApproved') }}</td>
                                <td class="text-right table-data">{{ formatTime(averageProjects.averagePreApprovedApproved) }}</td>
                            </tr>
                            <tr>
                                <td class="header-table">{{ $t('timeFromFinishedToApproved') }}</td>
                                <td class="text-right table-data">{{ formatTime(averageProjects.averageCreatedApproved) }}</td>
                            </tr>
                            <tr class="gris">
                                <td class="header-table">{{ $t('timeFromFinishedToDenied') }}</td>
                                <td class="text-right table-data">{{ formatTime(averageProjects.averageCreatedDenied) }}</td>
                            </tr>
                            
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
         </v-layout>
         <v-layout class="tables">
            <v-row style="justify-content:flex-start!important">
                <v-col cols="12" lg="6">
                    <p class="title-statistics mt-2">{{$t('totalByUser')}}</p>
                    <v-simple-table class="simple-table">
                        <template v-slot:default>
                        <tbody>
                            <tr class="gris">
                                <td class="header-table">{{$t('selectAnUser')}}</td>
                                <td> 
                                    <v-autocomplete
                                        v-model="userSelected"
                                        :items="usersList"
                                        class="autocomplete"
                                        item-text="type"
                                        item-value="value"
                                         @change="getUsersTotal()"
                                         :label="$t('enterOrSelectUser')"
                                    >
                                    </v-autocomplete>
                                </td>
                            </tr>
                            <tr>
                                <td class="header-table">{{$t('downloadedProjects') }}</td>
                                <td class="text-right table-data">{{totalProjectsByUsername}}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-layout>
        <p class="min-res">{{$t('minimunResolution')}}</p>
        </v-container>
    </v-container>
</template>

<script>
import StatisticsMixin from '@/mixins/StatisticsMixin'
import FilterMixin from '@/mixins/FilterMixin'
export default {
  components:{
    ItemList: ()=> import('@/components/base/ItemList'),
    TableFooter: ()=>import('@/components/base/TableFooter'),
  },
  mixins: [StatisticsMixin, FilterMixin],
  data () {
    return {
        userSelected: '',
        projects: [],
        sortBy: undefined,
        sortDesc: undefined,
        organismSelected: '',
        totalByTypeOfCrime: [],
        crimeTypeSelected: '',
        crimeTypeList: [],
        organismList: [],
        totalByOrganism: 0,
        totalProjects: {
            totalProjectsApproved: 0,
            totalProjectsPreApproved: 0,
            totalProjectsDenied: 0,
            totalProjectsCreated: 0,
        },
        averageProjects: {
            averageCreatedPreApproved: 0,
            averageCreatedApproved: 0,
            averageCreatedDenied: 0,
            averagePreApprovedApproved: 0
        },
        usersList: [],
        totalProjectsByUsername: 0,
        startDate: '',
        range: 'day'
    }
  },
  computed:{
       headers: {
        get(){
            return [
                {text: this.$t('projectName'), align: 'start', value: 'projectName'},
                {text: this.$t('createdBy'), align: 'start', value: 'createdBy'},
                {text: this.$t('lastModificationMadeBy'), align: 'start', value: 'statusLogs'},
                {text: this.$t('created'), align: 'start', value: 'creationDate'},
                {text: this.$t('resultStatus.PreApproved'), align: 'start', value: 'preApproved'},
                {text: this.$t('resultStatus.Approved'), align: 'start', value: 'approved'},
                {text: this.$t('resultStatus.Denied'), align: 'start', value: 'denied'},
                {text: this.$t('expirationDate'), align: 'start', value: 'expirationDate'},
                {text: this.$t('numberOfDownloads'), align: 'start', value: 'downloadsCount'}
            ]
        }
    },
  },
  watch: {
  },
  created(){
    this.startDate = this.$store.getters.getStartDate
      this.range = this.$store.getters.getRange
      this.getData();
  },
  beforeDestroy(){
    clearInterval(this.interval)
    this.interval = 0
  },
  async mounted(){
    await this.setRequestInterval()
    this.getUsersList()
    this.getUsersTotal()
  },
  methods: {
    getUsersList(){
      this.$extractions.getUsers().then(response=>{
        let users = []
        response.data.forEach(u => {
            users.push(u.username)
        })
        this.usersList = users
      }).catch(e=>{
        console.log('Error: ', e)
      })      
    },
    getSortedBy(sortBy, desc){
      this.sortBy = sortBy
      this.sortDesc = desc
      this.setRequestInterval(this.page, this.itemsPerPage)
    },
    async setRequestInterval(page=1, itemsPerPage=10){
      this.page=page
      this.itemsPerPage = itemsPerPage
      if(this.interval!==0)
        clearInterval(this.interval)
      await this.getData()
      this.interval = setInterval(this.getData,50000)
    },
    async getData(){
      this.$extractions.getStatisticsSystem(this.page,this.itemsPerPage,this.search,this.sortBy, this.sortDesc, this.startDate, this.range).then(response=>{
        if(response.data.length===0){
          if((this.search!=="")&&(this.page===1)){
            this.projects = []
            this.totalProjects = []    
          }
          if(this.page>1){
            this.page --
            this.$refs.tfooter.stepBack(this.page)
          }else{
            this.$refs.tfooter.stepBack(1)
          }
        } else {
            this.projects = response.data.projects
            this.totalProjects.totalProjectsApproved = response.data.totalApprovedProjects
            this.totalProjects.totalProjectsPreApproved = response.data.totalPreApprovedProjects
            this.totalProjects.totalProjectsDenied = response.data.totalDeniedProjects
            this.totalProjects.totalProjectsCreated = response.data.totalCreatedProjects
            this.totalProjects.totalDownloadsProjects = response.data.totalDownloadsProjects
            this.averageProjects.averageCreatedPreApproved = response.data.averageCreatedPreApproved
            this.averageProjects.averageCreatedApproved = response.data.averageCreatedApproved
            this.averageProjects.averageCreatedDenied = response.data.averageCreatedDenied
            this.averageProjects.averagePreApprovedApproved = response.data.averagePreApprovedApproved
        }        
      }).catch(()=>{
        
        return null
      })
    },
    getUsersTotal(){
        this.$extractions.getUsersTotal(this.search, this.userSelected, this.startDate, this.range).then(response=>{
            this.totalProjectsByUsername = response.data.totalProjects
           
      }).catch((e)=>{
        
        console.log(e)
      })
    },
    formatTime(value){
        if(value !== null){
            let datetime = value.toString()
            let day = datetime.split(' ')[0]
            let time = datetime.split(' ')[1]
            if(day == '01'){
                return day.split('')[1] + ' Día - ' + time + ' Hs.'
            } else if(day !== '00') {
                return day.split('')[1] + ' Días - ' + ' ' + time + ' Hs.'
            } else{
                return time + ' Hs.'
            }
        } else{
            return '00:00:00 Hs.'
        }
    },
    refreshPage(){
        this.getUsersTotal()
    },
    onRefresh(){
        this.getData()
        this.refreshPage()
    }
  }
  
}
</script>
<style>
    
    .title-statistics{
        font-size:18px!important;
        font-family: 'Roboto', 'sans-serif';
        color: #0d5ae5;
    }
    .tables{
        width: 80%;
        margin: 0 auto;
    }
    .simple-table{
        border: 1px solid #ccc;
    }
    .gris:hover{
        background-color: #f8faff!important;
    }
    .gris{
        background-color: #f8faff!important;
    }
    .header-table{
        font-size: 12px!important;
        font-weight: 600!important;
        width: 60%!important;
    }
    .min-res{
        position: absolute!important;
        font-size: 10px!important;
        text-align: right!important;
        bottom: -35px!important;
        right: 0px!important;
    }
    @media (max-width: 1200px) {
        .table-data{
            font-size: 13px!important;
        }
    }
     @media (max-width: 700px) {
        .tables{
            width: 100%!important;
        }
        .table-data{
            font-size: 12px!important;
        }
        .autocomplete input{
            font-size: 12px!important;
        }
    }
    @media (max-width: 450px) {
        .total-container{
            margin-left: -20px!important;
        }
    }
</style>